import{m as t}from"./chunk-HBP5N4FR.js";t();import a from"moment";function H({value:e,noSeconds:m,utc:o}){return o?a.utc(e*1e3).format(`MMM DD, YYYY HH:mm${m?"":":ss"} A UTC`):a(e*1e3).format(`MMM DD, YYYY HH:mm${m?"":":ss"} A`)}export{H as a};
//# sourceMappingURL=chunk-4KUTS6ZV.js.map
